import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const CHECK_MS = 120000;

@Injectable({
  providedIn: 'root',
})
export class AppUpdateCheckService {
  private started = false;

  start(): void {
    if (this.started) {
      return;
    }
    this.started = true;
    setInterval(() => void this.check(), CHECK_MS);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        void this.check();
      }
    });
  }

  private async check(): Promise<void> {
    try {
      const response = await fetch(`assets/version.json?t=${Date.now()}`, {
        cache: 'no-store',
      });
      if (!response.ok) {
        return;
      }
      const { version } = await response.json();
      if (version && version !== environment.buildId) {
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
    }
  }
}
